<template>
  <div class="swiper-banner" :class="{ load: showData.length === 0 }">
    <div :class="`swiper-container${showIndex} pic`">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in showData"
          :key="index"
        >
          <img class="pc" :src="item.src" alt="" />
          <img class="wap" :src="item.src" alt="" />
        </div>
      </div>
      <div class="swiper-pagination" v-if="showData.length > 1"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
export default {
  props: {
    showData: {
      type: Array,
      default: () => [], // 修正为返回空对象，但在此示例中未使用
    },
    showIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      content: "",
      pageIndex: 1,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        /* eslint-disable no-new */
        new Swiper(`.swiper-container${this.showIndex}`, {
          pagination: ".swiper-pagination",
          paginationClickable: true,
          autoplay: false,
          speed: 1000,
          loop: true,
        });
      });
    },
  },
};
</script>

<style scoped>
.swiper-banner {
  position: relative;
  max-width: 1190px;
  overflow: hidden;
}
.swiper-banner .pc {
  width: 100%;
  height: 20px;
  min-height: 600px;
  object-fit: cover;
  display: block;
}
.swiper-banner .wap {
  display: none;
}
.swiper-pagination {
  text-align: right;
  padding-right: 30px;
}
.swiper-pagination >>> .swiper-pagination-bullet {
  width: 20px;
  height: 4px;
  border-radius: 0;
  background-color: #fff;
  margin: 0;
  padding: 0;
}
.swiper-banner .swiper-pagination >>> span {
  margin: auto 4px !important;
  opacity: 1;
  width: 20px;
  height: 4px;
  background: url(../../assets/diandian_grey.png) no-repeat center;
  background-size: contain;
  border-radius: 0;
}
.swiper-banner .swiper-pagination >>> .swiper-pagination-bullet-active {
  width: 20px;
  height: 4px;
  background: none;
  position: relative;
  background: url(../../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
}
.swiper-pagination >>> .swiper-pagination-bullet-active::before {
  height: 0;
}
@media (max-width: 1440px) {
  .swiper-banner {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  .swiper-banner .pic,
  .swiper-banner .pc {
    width: 100%;
    height: 20px;
    min-height: 500px;
    object-fit: cover;
  }

  .swiper-pagination {
    text-align: right;
    padding-right: 20px;
  }
}
@media (max-width: 960px) {
  .swiper-banner {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  .swiper-banner .pic,
  .swiper-banner .pc {
    display: none;
    width: 100%;
    height: 20px;
    min-height: 600px;
    object-fit: cover;
  }
  .swiper-banner .pic,
  .swiper-banner .wap {
    display: block;
    width: 100%;
    min-height: calc(100vw * 0.5);
    max-height: calc(100vh * 0.22);
    object-fit: cover;
  }
  .swiper-pagination {
    text-align: right;
    padding-right: 20px;
  }
  .swiper-banner .swiper-pagination >>> span {
    margin: auto 2px !important;
    opacity: 1;
    width: 16px;
    height: 3px;
    background: url(../../assets/diandian_grey.png) no-repeat center;
    background-size: contain;
    border-radius: 0;
  }
  .swiper-banner .swiper-pagination >>> .swiper-pagination-bullet-active {
    width: 16px;
    height: 3px;
    background: none;
    position: relative;
    background: url(../../assets/diandian_highllight.png) no-repeat center;
    background-size: contain;
  }
}
@media (max-width: 428px) {
  .swiper-banner .pic,
  .swiper-banner .wap {
    display: block;
    width: 100%;
    height: 100%;
    min-height: auto;
    max-height: 185px;
    object-fit: cover;
  }
}
</style>